import React from 'react';
import { Box, Button, List, ListItem, ListItemAvatar, ListItemText, Popover, Skeleton, Typography } from '@mui/material';
import styles from '../../../custom/style.module.css';
import flightStyles from './tabs/flightreport/reports.module.css';
import { dateTolocale } from 'utils/converter';
import http from 'utils/http';
import { getHistory } from 'utils/flight';


class History extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      anchorEl: null,
      loadingHistory: false,
      history_data: [],
    };
  }

  componentDidMount() {
    if (!this.props.id) {
      return;
    } else {
      this.fetchHistory();
    }
  }

  fetchHistory = (e = {}) => {
    if (e && e.currentTarget) {
      this.setState({ anchorEl: e.currentTarget });
    }
    this.setState({ loadingHistory: false });
    http.get('change_log?type=Flight&flightId=' + this.props?.id)
      .then(async({ data }) => {
        let newData = await getHistory(data);
        this.setState({
          history_data: newData,
          loadingHistory: true
        }, () => {
          if (this.props.printFunction) {
            this.props.printFunction(this.state.history_data, 'history');
          }
        });
      });
  };

  closeHistory = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    return (<>
      <Button size='small'
        title='History'
        variant='contained'
        color='primary'
        className={styles.historyIcon}
        onClick={(e) => this.fetchHistory(e)}
        disableElevation
        disableRipple
      >H
      </Button>
      <Popover
        open={Boolean(this.state.anchorEl)}
        anchorEl={this.state.anchorEl}
        onClose={this.closeHistory}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List sx={{
          width: '100%',
          maxWidth: 360,
          minWidth: 320,
          bgcolor: 'background.paper',
          p: 2,
          maxHeight: 400,
          minHeight: 200,
        }}>
          {this.state.loadingHistory ? (this.state.history_data.length > 0 ? this.state.history_data.map((row, index) => (
            <ListItem key={index} className={flightStyles.historyListItem}>
              <ListItemAvatar className={styles.mr2}>
                <Typography variant='span' color='white' bgcolor={row.bgColor && row.bgColor} textTransform={'uppercase'} fontSize='10px' fontWeight={800} px={0.5} py={0.25} borderRadius={'4px'} lineHeight={'normal'} minWidth={'70px'} display={'block'} textAlign={'center'}>{row.type}</Typography>
              </ListItemAvatar>
              <ListItemText
                className={flightStyles.historyListText}
                primaryTypographyProps={{
                  fontSize: 12,
                  color: 'primary.main',
                  fontWeight: 500,
                }}
                secondaryTypographyProps={{ fontSize: 12 }}
                primary={row.operation_desc ? row.operation_desc : 'N/A'}
                secondary={`${dateTolocale(row.created, 'DD MMM YYYY HH:mm')} | ${row?.user?.first_name + ' ' + row?.user?.last_name + ` (${row?.user?.role})`}`} />
            </ListItem>
          )) :
            <Box sx={{
              textAlign: 'center',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <Typography variant='span' color='textSecondary' fontSize='0.8rem'>No History Found</Typography></Box>)
            :
            Array.from({ length: 3 }).map((_, index) => <ListItem key={index}>
              <Skeleton variant='rectangular' width={300} height={100} />
            </ListItem>)
          }
        </List>
      </Popover>
    </>);
  }
}


export default History;